import React from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';

import { replacePropsWithPreview } from '../../utils';
import { trackCheckPriceAndAvailability, trackSendMessage } from '@/lib/tracking/tracking';

const {
    publicRuntimeConfig: { baseUrl, contextPath },
} = getConfig();

export const ProfileButton = (props) => {
    const encodedCanonicalUrl = encodeURIComponent(`${baseUrl}${contextPath}/ad.html?finnkode=${props.objectData.adId}`);
    const sendMessageLink = `/authorizemessaging.html?canonicalUrl=${encodedCanonicalUrl}&finnkode=${props.objectData.adId}`;

    const renderSendMessageOrSeeAvailability = () => {
        if (props.objectData.isPrivate || (!props.objectData.owner.deeplink && props.objectData.isAdmin)) {
            return (
                <a
                    className="button button--primary w-full max-w-full"
                    {...replacePropsWithPreview(
                        {
                            href: sendMessageLink,
                            onClick: () => trackSendMessage({ objectName: 'without calendar', objectData: props.objectData }),
                        },
                        props.objectData.isPreview
                    )}
                    data-testid="sendMessage">
                    Send melding
                </a>
            );
        } else {
            return (
                <a
                    className="button button--primary w-full max-w-full"
                    href={props.objectData.owner.deeplink ? props.objectData.owner.deeplink : props.objectData.owner.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackCheckPriceAndAvailability({ objectData: props.objectData })}
                    data-testid="seeAvailability">
                    Se tilgjengelighet
                </a>
            );
        }
    };

    return (
        !props.objectData.bookingEnabled && (
            <div className="my-16" data-testid="profileButton">
                {renderSendMessageOrSeeAvailability()}
            </div>
        )
    );
};

ProfileButton.propTypes = {
    objectData: PropTypes.object.isRequired,
};
